module.exports = __webpack_public_path__ + "img/ms.faa9e68d.jpg";